import React from "react";
import { UtensilsCrossed, Palmtree, Trees, Footprints, Palette, Coffee, Store, LucideIcon } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";
import { useVenueCategories, catName } from "@/hooks/useVenueCategories";

export const TYPE_ICON: Record<string, LucideIcon> = {
  restaurant: UtensilsCrossed, resort: Palmtree, gardens: Trees, stable: Footprints, studio: Palette, cafe: Coffee,
};

const TYPE_COLOR: Record<string, string> = {
  restaurant: "bg-rose-500/90 text-white",
  resort: "bg-sky-500/90 text-white",
  gardens: "bg-emerald-500/90 text-white",
  stable: "bg-amber-700/90 text-white",
  studio: "bg-fuchsia-500/90 text-white",
  cafe: "bg-orange-500/90 text-white",
  other: "bg-zinc-700/90 text-white",
};

export const TypeBadge = ({ type, className = "" }: { type: string; className?: string }) => {
  const { lang } = usePrefs();
  const cats = useVenueCategories();
  const name = catName(cats, type, lang);
  if (!name) return null;
  const Icon = TYPE_ICON[type] || Store;
  return (
    <span data-testid="venue-category-badge" className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold backdrop-blur ${TYPE_COLOR[type] || TYPE_COLOR.other} ${className}`}>
      <Icon className="h-3.5 w-3.5" />
      {name}
    </span>
  );
};

export const StatusPill = ({ status }: { status: string }) => {
  const { t } = usePrefs();
  const cls =
    status === "confirmed" || status === "approved" || status === "checked_in"
      ? "bg-emerald-500/15 text-emerald-600 dark:text-emerald-400"
      : status === "pending"
      ? "bg-amber-500/15 text-amber-600 dark:text-amber-400"
      : status === "suspended"
      ? "bg-zinc-500/20 text-zinc-700 dark:text-zinc-300"
      : "bg-rose-500/15 text-rose-600 dark:text-rose-400";
  return <span data-testid={`status-pill-${status}`} className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold ${cls}`}>{t(`status.${status}`)}</span>;
};
